import { find } from "lodash";
import React, { useCallback, useEffect, useState, useMemo } from "react";
import { useSelector } from "react-redux";
import LabelTextField from "../../components/shared/LabelTextField";
import Dropdown from "../../components/shared/DropDown";
import { Button, Grid, Container, Card, Chip, Typography, Box } from "@mui/material";
import List from "../../components/shared/List";
import Dialog from "../../components/shared/Dialog";

import Iconify from "../../components/iconify/iconify";
import { useDispatch } from "react-redux";

import RHFAutocomplete from "../../components/shared/RHFAutocomplete";
import { color } from "../../utils/constant";

import { useForm } from "react-hook-form";

import {
  getDoctorList,
  getPaginationInfo,
  getPatientList,
  getReviewList,
} from "../../data/selectors/Review/Review.selector";
import useReview from "../../data/talons/Review/useReview";
import ReviewForm from "./ReviewForm";
import { useReviewForm } from "../../data/talons/Review/useReviewForm";

export default function Review() {
  const [showDialog, setShowDialog] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [editId, setEditId] = useState(null);
  const [Open, setOpen] = useState(false);
  const ReviewList = useSelector(getReviewList);
  const doctorList = useSelector(getDoctorList);
  const patientList = useSelector(getPatientList);
  const paginationInfo = useSelector(getPaginationInfo);

  const { getReviewById, handleDeleteId, deleteReviewData } = useReviewForm({});

  const {
    gridHeaders,
    loading,
    loader,
    status,
    StatusList,
    DoctorId,
    PatientId,
    finddoctorFromLabel,
    findpatientFromLabel,
    handleStatusChange,
    fetchReviewList,
    fetchDoctorComboList,
    fetchPatientComboList,
  } = useReview();

  useEffect(() => {
    fetchDoctorComboList();
    fetchPatientComboList();
    fetchReviewList({
      current_page: 1,
      row_count: rowsPerPage,
    });
  }, [rowsPerPage]);

  const { setValue, control } = useForm();
  const onSubmit = useCallback(
    async (e) => {
      e?.preventDefault();
      await fetchReviewList({
        current_page: 1,
        row_count: rowsPerPage,
      });
    },
    [fetchReviewList]
  );
  const editObj = useMemo(() => {
    return find(ReviewList, ["id", editId]);
  }, [editId, ReviewList]);

  return (
    <Container
      sx={{
        flexGrow: 1,
        display: "flex",
        flexDirection: "column",
        mt: 1,
      }}
    >
       <Grid
          item
          xs={6}
          sm={3}
          md={2}
          sx={{ marginLeft: "auto", textAlign: "end" }}
        ><Dialog
        handleClose={() => {
          setOpen(false);
        }}
        open={Open}
        // fullWidth={true}
      >
        <Typography sx={{ fontWeight: "bold" }}>
          Confirm to Delete this Data ?.
        </Typography>
        <Box sx={{ display: "flex", gap: 1, mt: 2, justifyContent: "end" }}>
          <Button
            onClick={async () => {
              const res = await deleteReviewData();
              if (res === true) {
                setOpen(false);
                await deleteReviewData(editId);
                fetchReviewList({ current_page: 1, row_count: rowsPerPage });
              }
            }}
            sx={{ background: color.button }}
            variant="contained"
          >
            Yes
          </Button>
          <Button
            onClick={() => setOpen(false)}
            sx={{ background: color.button }}
            variant="contained"
          >
            No
          </Button>
        </Box>
      </Dialog></Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={3} md={2}>
          <RHFAutocomplete
            borderRadius={"12px"}
            name="doctor_name"
            label="Doctor Name"
            disabled={editId ? true : false}
            freeSolo
            data={doctorList || []}
            defaultValue={DoctorId}
            onInputChange={(value) => finddoctorFromLabel(value)}
            id={doctorList?.map((option) => option.id)}
            renderOption={(props, option) => (
              <>
                <li {...props} key={option}>
                  {option}
                </li>
              </>
            )}
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option}
                  label={option}
                  size="small"
                  color="info"
                  variant="soft"
                />
              ))
            }
            control={control}
            setValue={setValue}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <RHFAutocomplete
            borderRadius={"12px"}
            name="patient_name"
            label="Patient Name"
            disabled={editId ? true : false}
            freeSolo
            data={patientList || []}
            defaultValue={PatientId}
            onInputChange={(value) => findpatientFromLabel(value)}
            id={patientList?.map((option) => option.id)}
            renderOption={(props, option) => (
              <>
                <li {...props} key={option}>
                  {option}
                </li>
              </>
            )}
            renderTags={(selected, getTagProps) =>
              selected.map((option, index) => (
                <Chip
                  {...getTagProps({ index })}
                  key={option}
                  label={option}
                  size="small"
                  color="info"
                  variant="soft"
                />
              ))
            }
            control={control}
            setValue={setValue}
          />
        </Grid>
        <Grid item xs={12} sm={3} md={2}>
          <Dropdown
            size={"small"}
            title={"Status"}
            data={StatusList}
            handleDropdownChange={handleStatusChange}
            dropdownValue={status}
            allReqired={true}
            allStatusVal="0"
          />
        </Grid>
        <Grid
          container
          direction="row"
          justify="flex-right"
          item
          xs={6}
          sm={3}
          md={2}
        >
          <Button
            variant="contained"
            onClick={onSubmit}
            sx={{
              maxHeight: 40,
              backgroundColor: color.button,
              borderRadius: 3,
              "&:hover": {
                backgroundColor: color.button,
              },
            }}
          >
            Get Data
          </Button>
        </Grid>
        <Grid
          item
          xs={6}
          sm={3}
          md={2}
          sx={{ marginLeft: "auto", textAlign: "end" }}
        >
          <Dialog
            handleClose={() => {
              setShowDialog(false);
              setEditId(null);
              fetchReviewList({ current_page: 1, row_count: rowsPerPage });
            }}
            open={showDialog}
            fullWidth={true}
          >
            <ReviewForm
              postSubmit={async () => {
                setShowDialog(false);
                setEditId(null);
                await fetchReviewList({
                  current_page: 1,
                  row_count: rowsPerPage,
                });
              }}
              editId={editId}
              editItem={editObj}
            />
          </Dialog>
        </Grid>
      </Grid>
      <Card
        sx={{
          flexGrow: { md: 1 },
          display: { md: "flex" },
          flexDirection: { md: "column" },
          my: "12px",
          borderRadius: "12px",
          boxShadow:
            "0 0 2px 0 rgba(145, 158, 171, 0.2),0 12px 24px -4px rgba(145, 158, 171, 0.12)",
        }}
      >
        <List
          loading={loading}
          data={ReviewList}
          paginationData={paginationInfo}
          columnsData={gridHeaders}
          getRowId={(row) => row.id}
          autoHeight={true}
          pageCount={Number(paginationInfo.total_page)}
          totalRecords={paginationInfo.total_count}
          onPageChange={async (page, rowsPerPage) => {
            setRowsPerPage(rowsPerPage);
            await fetchReviewList({
              current_page: page,
              row_count: rowsPerPage,
            });
          }}
          enableDelete
          onDeleteIconpress={async (row) => {
            handleDeleteId(row);
            setOpen(true);
          }}
          enableEdit
          onEditIconPress={async (id) => {
            await getReviewById(id); 
            setEditId(id);
            setShowDialog(true);
          }}
        />
      </Card>
    </Container>
  );
}
